/**
 * Color Design Tokens
 * 
 * This file defines all color tokens that can be shared between platforms.
 */

// Primary colors
export const colors = {
  // Primary brand colors (refined red palette with premium depth)
  primary: {
    50: '#fff5f5',   // Softer, warmer white
    100: '#ffe3e3',  // Subtle pink undertone
    200: '#ffc9c9',  // Soft rose
    300: '#ffa7a7',  // Muted coral
    400: '#ff8585',  // Vibrant light red
    500: '#ff5252',  // Main brand red (unchanged)
    600: '#e53935',  // Rich red
    700: '#c62828',  // Deep burgundy
    800: '#b71c1c',  // Premium wine red
    900: '#8e0000',  // Rich dark red
  },
  
  // Neutral colors with warmer undertones
  neutral: {
    50: '#fafaf9',   // Warm white
    100: '#f5f5f4',  // Subtle warm gray
    200: '#e7e5e4',  // Light warm gray
    300: '#d6d3d1',  // Medium warm gray
    400: '#a8a29e',  // Balanced warm gray
    500: '#78716c',  // Rich warm gray
    600: '#57534e',  // Deep warm gray
    700: '#44403c',  // Dark warm gray
    800: '#292524',  // Rich dark gray
    900: '#1c1917',  // Almost black with warmth
  },
  
  // Premium black shades with sophisticated warm undertones
  premium: {
    50: '#faf9f8',   // Refined warm white
    100: '#f2f0ee',  // Sophisticated light
    200: '#e5e2df',  // Elegant light gray
    300: '#cbc5c0',  // Premium medium light
    400: '#a39992',  // Luxurious taupe
    500: '#857770',  // Rich warm gray
    600: '#625750',  // Deep taupe
    700: '#463d38',  // Premium dark
    800: '#2c2522',  // Sophisticated dark
    900: '#1a1614',  // Luxurious black
  },
  
  // Metallic accents (new)
  metallic: {
    gold: {
      light: '#f5d485',
      main: '#deb867',
      dark: '#b89544',
    },
    silver: {
      light: '#e2e8f0',
      main: '#cbd5e1',
      dark: '#94a3b8',
    },
    copper: {
      light: '#e8aa8c',
      main: '#d48a6a',
      dark: '#b66d4d',
    }
  },
  
  // Enhanced amber palette for luxury accents
  amber: {
    50: '#fff8e1',   // Softest gold
    100: '#ffecb3',  // Light gold
    200: '#ffe082',  // Pale gold
    300: '#ffd54f',  // Bright gold
    400: '#ffca28',  // Rich gold
    500: '#ffc107',  // Pure gold
    600: '#ffb300',  // Deep gold
    700: '#ffa000',  // Intense gold
    800: '#ff8f00',  // Burnt gold
    900: '#ff6f00',  // Dark gold
  },
  
  // Semantic colors with premium adjustments
  success: {
    light: '#86efac',  // Brighter green
    main: '#10b981',   // Rich emerald
    dark: '#059669',   // Deep emerald
  },
  error: {
    light: '#fca5a5',  // Soft red
    main: '#ef4444',   // Vibrant red
    dark: '#dc2626',   // Deep red
  },
  warning: {
    light: '#fcd34d',  // Bright amber
    main: '#f59e0b',   // Rich amber
    dark: '#d97706',   // Deep amber
  },
  info: {
    light: '#93c5fd',  // Bright blue
    main: '#3b82f6',   // Rich blue
    dark: '#2563eb',   // Deep blue
  },
  
  // Base colors
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
}; 